import { PRODUCT_GROUP } from 'helpers/constants';

export const get = (object, path = '') => path
  .replace(/\[/g, '.')
  .replace(/\]/g, '')
  .split('.')
  .reduce((o, k) => (o || {})[k], object);

export const groupBy = (data, field) => data.reduce((prev, current) => {
  (prev[current[field]] = prev[current[field]] || []).push(current);
  return prev;
}, {});

export const normalizeProductGroup = (value, { emptyValue = '' } = {}) => {
  const raw = String(value || '').trim();
  if (!raw) return emptyValue;

  const groupShcheben = PRODUCT_GROUP.toString(PRODUCT_GROUP.ONE);
  const groupOtsev = PRODUCT_GROUP.toString(PRODUCT_GROUP.TWO);

  const upper = raw.toUpperCase();
  if (upper.includes('ОТСЕВ')) return groupOtsev;
  if (upper.includes('ЩЕБЕН') || upper.includes('ПОРОДА СКАЛ')) return groupShcheben;

  return raw;
};

export const DNDData = ({
  data,
  droppableType,
  draggableFilter = () => true,
}) => {
  const getType = (item) => {
    const types = droppableType ? droppableType.split(';') : 'all';
    return types.map((type) => {
      const key = get(item, type) !== undefined ? get(item, type) : 'default';
      return key;
    }).join('-');
  };

  const items = data.reduce((prev, current, realIndex) => {
    const { length } = prev;
    const key = getType(current);
    const isEnabledDrop = draggableFilter(current);
    const item = { item: current, realIndex };

    if (length) {
      const last = prev[length - 1];

      if (droppableType) {
        const some = last
          .some(({ item: value }, i) => i >= 2 && getType(value) === getType(current));

        if (some && isEnabledDrop === last[1]) {
          last.push(item);
        } else {
          prev.push([key, isEnabledDrop, item]);
        }
      } else if (isEnabledDrop === last[1]) {
        last.push(item);
      } else {
        prev.push([key, isEnabledDrop, item]);
      }
    } else {
      prev.push([key, isEnabledDrop, item]);
    }

    return prev;
  }, []);

  return {
    data: items,
    getItem(droppableId, index) {
      const item = this.data[droppableId][index + 2];
      const prev = this.data[droppableId][index + 1];

      return index > 0
        ? (item || { realIndex: prev.realIndex + 1 })
        : item;
    },
    onUpdate(result) {
      const {
        destination: {
          index: destinationIndex,
          droppableId: destinationDroppableId,
        },
        source: {
          index: sourceIndex,
          droppableId: sourceDroppableId,
        },
      } = result;

      const destinationMatch = Number(destinationDroppableId.match(/\[(\d+)\]$/)[1]);
      const sourceMatch = Number(sourceDroppableId.match(/\[(\d+)\]$/)[1]);

      return Promise.resolve({
        destination: this.getItem(destinationMatch, destinationIndex),
        source: this.getItem(sourceMatch, sourceIndex),
      });
    },
  };
};
